<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5" v-if="form != null">
          <section>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Firstname</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="firstname"
                  class="w-full"
                  v-model="form.speaker_firstname"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('firstname')"
                  >{{ errors.first("firstname") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Lastname</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="lastname"
                  class="w-full"
                  v-model="form.speaker_lastname"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('lastname')"
                  >{{ errors.first("lastname") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Display Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="displayname"
                  class="w-full"
                  v-model="form.speaker_displayname"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('displayname')"
                  >{{ errors.first("displayname") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Tag Line</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="tagline"
                  class="w-full"
                  v-model="form.speaker_tagline"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('tagline')"
                  >{{ errors.first("tagline") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="shortdesc"
                  class="w-full"
                  v-model="form.speaker_shortdesc"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('shortdesc')"
                  >{{ errors.first("shortdesc") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Long Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  rows="5"
                  name="longdesc"
                  class="w-full"
                  v-model="form.speaker_longdesc"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('longdesc')"
                  >{{ errors.first("longdesc") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Phone</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="phone"
                  class="w-full"
                  v-model="form.speaker_phone"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('phone')"
                  >{{ errors.first("phone") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Email</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="email"
                  class="w-full"
                  v-model="form.speaker_email"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('email')"
                  >{{ errors.first("email") }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Website (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="website"
                  class="w-full"
                  v-model="form.speaker_website"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('website')"
                  >{{ errors.first("website") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Facebook (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="facebook"
                  class="w-full"
                  v-model="form.speaker_facebook"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('facebook')"
                  >{{ errors.first("facebook") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Twitter (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="twitter"
                  class="w-full"
                  v-model="form.speaker_twitter"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('twitter')"
                  >{{ errors.first("twitter") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Linkedin (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="linkedin"
                  class="w-full"
                  v-model="form.speaker_linkedin"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('linkedin')"
                  >{{ errors.first("linkedin") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Youtube (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="youtube"
                  class="w-full"
                  v-model="form.speaker_youtube"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('youtube')"
                  >{{ errors.first("youtube") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Weight</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="websweightite"
                  class="w-full"
                  v-model="form.weight"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('weight')"
                  >{{ errors.first("weight") }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Filter</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select class="selectExample" v-model="form.speaker_filter">
                  <vs-select-item
                    :key="index"
                    :value="item.filter_id"
                    :text="item.filter_name"
                    v-for="(item, index) in filterList"
                  />
                </vs-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('filter')"
                  >{{ errors.first("filter") }}</span
                >
              </div>
            </div>
          </section>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Update</vs-button
              >
            </div>
          </div>
        </vs-card>
        <vs-card class="px-5 py-5">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Profile Image</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <img
                :src="form.speaker_profile_img"
                style="width: 120px"
                class="mb-5"
              />
              <vs-input
                type="file"
                ref="speaker_profile_image"
                name="speaker_profile_image"
                class="w-full"
                v-model="form.speaker_profile_img"
                @change="setProfileImg"
              />
              Dimension must be 500x500px and file size must not be more than
              1MB
              <span
                class="text-danger text-sm"
                v-show="errors.has('speaker_profile_image')"
                >{{ errors.first("speaker_profile_image") }}</span
              >
            </div>
          </div>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" @click.prevent="doUploadFile"
                >Upload</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";
export default {
  components: {},
  props: ["id"],
  data: () => ({
    suffixParams: "",
    valid: true,
    form: {
      speaker_profile_img: "",
    },
    filterList: [],
    file: {
      speaker_profile_img: null,
    },
  }),
  created() {
    setTimeout(() => {
      this.suffixParams =
        "?s=" + this.$route.query.s + "&e=" + this.$route.query.e;
      Service.Speaker.get(this.id, this.$route.query.e).then((res) => {
        this.form = res.data.speaker;
        this.loadFilter();
      });
    }, 1000);
  },
  methods: {
    loadFilter() {
      let filterData = {
        e: this.$route.query.e,
        m: "speaker",
        currentPage: 1,
        perPage: 50,
      };

      let params = Object.keys(filterData)
        .map((key) => key + "=" + filterData[key])
        .join("&");

      Service.Filter.gets(params).then((res) => {
        this.filterList = res.data.rows;
      });
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        ...this.form,
      };

      this.$vs.loading();
      Service.Speaker.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          this.$router.push(
            "/conferences/speakers?s=" +
              this.$route.query.s +
              "&e=" +
              this.$route.query.e
          );
        }
        this.$vs.loading.close();
      });
    },
    setProfileImg(e) {
      this.file.speaker_profile_img = e.target.files[0];
    },
    doUploadFile() {
      this.$vs.loading();
      var formData = new FormData();

      formData.append("e", this.$route.query.e);

      if (this.file.speaker_profile_img != null) {
        formData.append("speaker_profile_img", this.file.speaker_profile_img);
      }

      Service.Speaker.upload(this.id, formData).then((res) => {
        if (res.success) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          window.location.href = "/conferences/speakers" + this.suffixParams;
        }
      });
    },
  },
};
</script>